import { useCounter } from "../../lib/animations";
import { useHomepageContent } from "@/lib/homepageContent";

function StatItem({ stat }) {
  const target = Number(stat.value) || 0;
  const decimals = Number(stat.decimals) || 0;
  const [val, ref] = useCounter(target, 2400);
  const display = decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString("nl-BE");
  return (
    <div ref={ref} className="text-center">
      <p className="font-mono font-semibold text-[40px] sm:text-[48px] leading-none text-oc-primary tracking-tight">
        {stat.prefix || ""}
        {display}
        {stat.suffix || ""}
      </p>
      <p className="mt-3 text-oc-textSecondary text-[14px] uppercase tracking-[0.05em] font-medium">
        {stat.label}
      </p>
    </div>
  );
}

export default function StatsBar() {
  const { stats } = useHomepageContent();
  return (
    <section data-testid="stats-bar" className="bg-oc-subtle border-y border-oc-border">
      <div className="oc-container py-16 grid grid-cols-2 md:grid-cols-4 gap-12">
        {stats.map((s, i) => (
          <StatItem key={i} stat={s} />
        ))}
      </div>
    </section>
  );
}
